import React from 'react'

export function Footer() {
  return (
    <footer className="bg-neutral-950 text-neutral-400 py-8 px-4 md:px-8 border-t border-neutral-200 mt-auto">
      <div className="container mx-auto flex flex-col items-start md:flex-row md:justify-between gap-6 max-w-6xl">
        <div className="flex items-center gap-4 md:order-1">
          <a
            href="https://x.com/curated_hq"
            className="text-neutral-400 cursor-pointer"
          >
            <img src="/icons/x.svg" alt="Twitter" width={20} height={20} />
            <span className="sr-only">Twitter</span>
          </a>
          <a
            href="https://t.me/ImpossibleFinance"
            className="text-neutral-400 cursor-pointer"
          >
            <img
              src="/icons/telegram.svg"
              alt="Telegram"
              width={20}
              height={20}
            />
            <span className="sr-only">Telegram</span>
          </a>
        </div>
        <div className="flex flex-col items-start md:flex-row md:items-center md:gap-x-6 md:order-2">
          <nav className="flex flex-col items-center md:flex-row md:flex-wrap md:justify-center gap-y-2 text-sm md:gap-x-6">
            <a
              href="https://impossible.finance/terms"
              className="hover:text-brand-hover"
            >
              Terms
            </a>
            <a
              href="https://impossible.finance/privacy"
              className="hover:text-brand-hover"
            >
              Privacy Policy
            </a>
          </nav>
          <span className="text-sm text-neutral-400 mt-2 md:mt-0">
            © 2025 CURATED
          </span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
